import { jsxs as pr, jsx as m, Fragment as Rr } from "react/jsx-runtime";
import { DotsIcon as Hr } from "@systemeio/ui/icons";
import { Popover as Wr } from "@systemeio/ui";
import xr, { useRef as k, useState as zr, useTransition as Kr, useMemo as S, useEffect as Mr, Fragment as Nr } from "react";
import { twMerge as yr, twJoin as Ar } from "tailwind-merge";
import { EditorExtensionEnum as e } from "../enums/editor-extensions-enum.mjs";
import { getExistingExtensions as wr } from "../utils/get-extensions.mjs";
import { renderInSemanticOrder as v } from "./render-semantic-order.mjs";
import { semanticOrder as kr } from "./toolbar-semantic-order.mjs";
import { useImageExtensionToolbar as Pr } from "../extensions/image-extension/use-image-extension-toolbar.mjs";
import { useHistoryExtensionToolbar as Ur } from "../extensions/history-extension/use-history-extension-toolbar.mjs";
import { useIndentExtensionToolbar as Vr } from "../extensions/indent-extension/use-indent-extension-toolbar.mjs";
import { useLinkExtensionToolbar as jr } from "../extensions/link-extension/use-link-extension-toolbar.mjs";
import { useTextAlignExtensionToolbar as _r } from "../extensions/text-align-extension/use-text-align-extension-toolbar.mjs";
import { useHeadingExtensionToolbar as $r } from "../extensions/heading-extension/use-heading-extension-toolbar.mjs";
import { useSubstitutesExtensionToolbar as qr } from "../extensions/substitutes-extension/use-substitutes-extension-toolbar.mjs";
import { useTextFormatExtensionToolbar as E } from "../extensions/text-format-extension/use-text-format-extension-toolbar.mjs";
import { TextFormatEnum as g } from "../extensions/text-format-extension/text-format-enum.mjs";
import { useFontSizeExtensionToolbar as Dr } from "../extensions/font-size-extension/use-font-size-extension-toolbar.mjs";
import { useListExtensionToolbar as Sr } from "../extensions/list-extension/use-list-extension-toolbar.mjs";
import { ListEnum as vr } from "../extensions/list-extension/list-enum.mjs";
import { useFontFamilyExtensionToolbar as Jr } from "../extensions/font-family-extension/use-font-family-extension-toolbar.mjs";
import { useTextColorExtensionToolbar as Gr } from "../extensions/text-color-extension/use-text-color-extension-toolbar.mjs";
import { useTextBackgroundColorExtensionToolbar as Qr } from "../extensions/text-background-color-extension/use-text-background-color-extension-toolbar.mjs";
import { useSpecialCharactersExtensionToolbar as Xr } from "../extensions/special-characters-extension/use-special-characters-extension-toolbar.mjs";
import { useParagraphSpaceExtensionToolbar as Yr } from "../extensions/paragraph-extension/use-paragraph-space-extension.mjs";
import { useLineHeightExtensionToolbar as Zr } from "../extensions/line-height-extension/use-line-height-extension-toolbar.mjs";
const Le = ({
  extensions: Fr,
  editor: t,
  toolbarStyles: Lr,
  toolbarClassName: Ir,
  showAllItems: b = !1,
  extensionOptions: o
}) => {
  const {
    hasHistory: F,
    hasHeading: L,
    hasIndent: I,
    hasTextAlign: C,
    hasLink: B,
    hasTextColor: R,
    hasFontSize: H,
    hasTextBackgroundColor: W,
    hasFontFamily: z,
    hasSubstitution: K,
    hasSpecialCharacters: M,
    hasImage: N,
    hasOrderedList: A,
    hasBulletList: w,
    hasListItem: p,
    hasBold: P,
    hasItalic: U,
    hasUnderline: V,
    hasStrike: j,
    hasParagraph: _,
    hasSimpleHardBreak: $,
    hasLineHeight: q
  } = wr(Fr), u = k(null), D = k(null), [h, J] = zr([]), [, G] = Kr(), T = k([]), Q = Pr(
    t,
    o == null ? void 0 : o[e.Image]
  ), X = Ur(t), Y = Vr(t), Z = jr(
    t,
    o == null ? void 0 : o[e.Link]
  ), O = _r(t), rr = $r(t), er = qr(
    t,
    o == null ? void 0 : o[e.Substitution]
  ), or = E(t, g.Bold), tr = E(t, g.Italic), ar = E(t, g.Underline), ir = E(t, g.Strike), sr = Dr(
    t,
    o == null ? void 0 : o[e.FontSize]
  ), nr = Sr(t, vr.OrderedList), lr = Sr(t, vr.BulletList), cr = Jr(
    t,
    o == null ? void 0 : o[e.FontFamily]
  ), fr = Gr(
    t,
    o == null ? void 0 : o[e.TextColor]
  ), mr = Qr(
    t,
    o == null ? void 0 : o[e.TextBackgroundColor]
  ), ur = Xr(t), dr = Yr(t), br = Zr(t), i = S(() => {
    const a = [], r = (s, c) => {
      Array.isArray(s) ? s.forEach((n) => {
        a.push({
          toolbarItem: n,
          ref: xr.createRef(),
          key: c
        });
      }) : a.push({
        toolbarItem: s,
        ref: xr.createRef(),
        key: c
      });
    };
    return _ && !$ && r(dr, e.Paragraph), q && r(br, e.LineHeight), F && r(X, e.History), N && r(Q, e.Image), B && r(Z, e.Link), I && r(Y, e.Indent), C && r(O, e.TextAlign), L && r(rr, e.Heading), K && r(er, e.Substitution), P && r(or, e.Bold), U && r(tr, e.Italic), V && r(ar, e.Underline), j && r(ir, e.Strike), H && r(sr, e.FontSize), A && p && r(nr, e.OrderedList), w && p && r(lr, e.BulletList), z && r(cr, e.FontFamily), R && r(fr, e.TextColor), W && r(mr, e.TextBackgroundColor), M && r(ur, e.SpecialCharacters), a;
  }, [
    _,
    $,
    dr,
    q,
    br,
    F,
    X,
    N,
    Q,
    B,
    Z,
    I,
    Y,
    C,
    O,
    L,
    rr,
    K,
    er,
    P,
    or,
    U,
    tr,
    V,
    ar,
    j,
    ir,
    H,
    sr,
    A,
    p,
    nr,
    w,
    lr,
    z,
    cr,
    R,
    fr,
    W,
    mr,
    M,
    ur
  ]), hr = (a, r) => a.length === r.length && a.every((s, c) => s === r[c]);
  Mr(() => {
    const a = () => {
      var Er;
      if (!u.current) return;
      if (b) {
        const l = i.map((f) => f.key);
        hr(T.current, l) || (T.current = l, G(() => J(l)));
        return;
      }
      const s = u.current.clientWidth, c = [...i].sort(
        (l, f) => kr.flatMap((d) => d).indexOf(l.key) - kr.flatMap((d) => d).indexOf(f.key)
      ), n = [];
      let x = 0, y = !1;
      const Br = ((Er = D.current) == null ? void 0 : Er.offsetWidth) ?? 0;
      for (const l of c) {
        const f = l.ref.current;
        if (!f) continue;
        const d = f.offsetWidth, gr = x + d;
        !y && gr <= s ? (n.push(l.key), x = gr) : y = !0;
      }
      y && n.length > 0 && x + Br > s && n.pop(), hr(T.current, n) || (T.current = n, G(() => J(n)));
    }, r = new ResizeObserver(a);
    return u.current && r.observe(u.current), a(), () => {
      r.disconnect();
    };
  }, [i, b]);
  const Cr = S(
    () => i.filter((a) => h.includes(a.key)),
    [i, h]
  ), Tr = S(
    () => i.filter((a) => !h.includes(a.key)),
    [i, h]
  );
  return /* @__PURE__ */ pr(
    "div",
    {
      style: Lr,
      className: yr(
        "border-text-secondary/30 z-sticky bg-background-secondary sticky top-0 flex items-center rounded-t-lg border border-b-0 p-1",
        Ir
      ),
      children: [
        /* @__PURE__ */ pr(
          "div",
          {
            ref: u,
            className: yr("flex w-full", b && "flex-wrap gap-1"),
            children: [
              v({ source: Cr, skipRef: !0 }),
              /* @__PURE__ */ m(
                "div",
                {
                  ref: D,
                  className: Ar(
                    "ml-auto flex items-center",
                    Tr.length > 0 ? "visible" : "invisible",
                    b && "hidden"
                  ),
                  children: /* @__PURE__ */ m(
                    Wr,
                    {
                      anchor: "bottom end",
                      className: "main-transition-colors data-[open]:bg-brand-primary/10 group h-7 rounded-lg px-2",
                      label: /* @__PURE__ */ m(Rr, { children: v({
                        source: Tr,
                        skipRef: !0,
                        skipBorder: !0,
                        inTooltip: !0
                      }) }),
                      children: /* @__PURE__ */ m(Hr, { className: "group-hover:fill-brand-primary main-transition-colors" })
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: "pointer-events-none absolute left-0 top-0 flex h-0 overflow-hidden opacity-0", children: v({ source: i }) }),
        i.filter(({ toolbarItem: a }) => a.additionalRender).map(({ toolbarItem: a, key: r }) => /* @__PURE__ */ m(Nr, { children: a.additionalRender }, `${r}-additional-render`))
      ]
    }
  );
};
export {
  Le as Toolbar
};
